// name of the constant = route name in lower case

const carton = [
  {
    name: 'Code',
    query: 'code',
  },
  {
    name: 'Description',
    query: 'description',
  },
];

const carrier = [
  {
    name: 'Code',
    query: 'code',
    inputType: 'number',
  },
  {
    name: 'Description',
    query: 'description',
  },
];

const shipmethod = [
  {
    name: 'Code',
    query: 'code',
  },
  {
    name: 'Description',
    query: 'description',
  },
  {
    name: 'Caution Code',
    query: 'caution_codes__contains',
  },
  {
    name: 'Mode of transport',
    query: 'mode_of_transport',
  },
  {
    name: 'Domestic carriers',
    query: 'domestic_carriers__description__icontains',
  },
  {
    name: 'International carriers',
    query: 'international_carriers__description__icontains',
  },
];

const transportationdb = [
  {
    name: 'Sku',
    query: 'sku',
  },
  {
    name: 'Transport Mode',
    query: 'transport_mode',
  },
  {
    name: 'Category',
    query: 'category',
  },
  {
    name: 'UOM',
    query: 'uom',
  },
  {
    name: 'MAX QTY',
    query: 'max_quantity',
  },
  {
    name: 'PKG Details',
    query: 'pkg_detail',
  },
];

const transporter = [
  {
    id: 1,
    name: 'Transporter Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Ref Id',
    query: 'reference_id',
  },
  {
    id: 3,
    name: 'City',
    query: 'city',
  },
  {
    id: 4,
    name: 'State',
    query: 'state',
  },
  {
    id: 5,
    name: 'Pincode',
    query: 'pincode',
  },
];

const billdiscount = [
  {
    name: 'Program ID',
    query: 'program_id',
  },
  {
    name: 'Day Early',
    query: 'days_early',
  },
];

const contract = [
  {
    id: 1,
    name: 'Transporter Name',
    query: 'query',
  },
  {
    id: 2,
    name: 'Vehicle Name',
    query: 'vehicle_type',
  },
  {
    id: 3,
    name: 'Source',
    query: 'source',
  },
  {
    id: 4,
    name: 'Destination',
    query: 'destination',
  },
];

const vehicledetail = [
  {
    id: 1,
    name: 'Vehicle Number',
    query: 'vehicle_number',
  },
  {
    id: 2,
    name: 'Vehicle Name',
    query: 'vehicle_type',
  },
  {
    id: 3,
    name: 'Transporter',
    query: 'transporter',
  },
];

const consignee = [
  {
    id: 1,
    name: 'Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Reference Id',
    query: 'ref_id',
  },
  {
    id: 3,
    name: 'City',
    query: 'city',
  },
  {
    id: 4,
    name: 'State',
    query: 'state',
  },
  {
    id: 5,
    name: 'Region',
    query: 'region',
  },
  {
    id: 6,
    name: 'Postal Code',
    query: 'pincode',
  },
  {
    id: 7,
    name: 'Email Id',
    query: 'email_id',
  },
  {
    id: 8,
    name: 'Consignee Group',
    query: 'consignee_group',
    currentQuerySelected: 'group',
    multiDropDownQueryOptions: [
      {
        label: 'Group',
        tlabel: 'Group',
        typeLabel: 'Group',
        ttypeLabel: 'Group',
        name: 'Consignee Group',
        tname: 'INDENT_CONSIGNEE_GROUP',
        query: 'group',
      },
      {
        label: 'EPOD Group',
        tlabel: 'EPOD Group',
        typeLabel: 'EPOD Group',
        ttypeLabel: 'EPOD Group',
        name: 'Consignee EPOD Group',
        tname: 'INDENT_CONSIGNEE_EPOD_GROUP',
        query: 'epod_group',
      },
    ],
  },
];
const contracttsd = [
  {
    id: 1,
    name: 'Source',
    query: 'source',
  },
  {
    id: 2,
    name: 'Destination',
    query: 'destination',
  },
  {
    id: 3,
    name: 'Vehicle Name',
    query: 'vehicle_name',
  },
  {
    id: 4,
    name: 'Transporter',
    query: 'query',
    tname: 'Transporter',
    currentQuerySelected: 'query',
    multiDropDownQueryOptions: [
      { label: 'in Ref ID', name: 'Transporter Ref Id', typeLabel: 'Ref Id', query: 'transporter_refId' },
      { label: 'in Name', name: 'Transporter Name', typeLabel: 'Name', query: 'transporter_name' },

    ],
  },
];


const destination_charge = [
  {
    id: 1,
    name: 'Destination',
    query: 'destination',
  },
  {
    id: 2,
    name: 'Transporter Ref Id',
    query: 'transporter_ref_id',
  },
  {
    id: 3,
    name: 'Remarks',
    query: 'remarks',
  },
];

const source_charge = [
  {
    id: 1,
    name: 'Source',
    query: 'source',
  },
  {
    id: 2,
    name: 'Transporter Ref Id',
    query: 'transporter_ref_id',
  },
];

const user = [
  {
    id: 1,
    name: 'Name',
    query: 'query',
  },
];

const package_master = [
  {
    id: 1,
    name: 'Package id',
    query: 'package_id',
  },
];

const material_package_map = [
  {
    id: 1,
    name: 'Package id',
    query: 'package_id',
  },
];

const depot = [
  {
    id: 1,
    name: 'Depot',
    query: 'query',
    currentQuerySelected: 'query',
    multiDropDownQueryOptions: [
      { label: 'in Ref ID', name: 'Depot Ref Id', typeLabel: 'Ref Id', query: 'reference_id' },
      { label: 'in Name', name: 'Depot Name', typeLabel: 'Name', query: 'name' },
    ],
  },
  {
    id: 7,
    name: 'Gate',
    query: 'gate',
    currentQuerySelected: 'gate',
    multiDropDownQueryOptions: [
      { label: 'in Ref ID', name: 'Gate Ref Id', typeLabel: 'Ref Id', query: 'gate_reference_id' },
      { label: 'in Name', name: 'Gate Name', typeLabel: 'Name', query: 'gate_name' },
    ],
  },
  {
    id: 2,
    name: 'State',
    query: 'state',
  },
  {
    id: 3,
    name: 'Region',
    query: 'region',
  },
  {
    id: 4,
    name: 'Pin  Code',
    query: 'pincode',
  },
  {
    id: 5,
    name: 'City',
    query: 'city',
  },
  {
    id: 6,
    name: 'Short Code',
    query: 'short_code',
  }];
const detention = [
  {
    id: 1,
    name: 'Truck Type',
    query: 'vehicle_type',
  },
  {
    id: 2,
    name: 'Group',
    query: 'group',
  },
];

const sla = [
  {
    id: 1,
    name: 'Vehicle Type',
    query: 'vehicle_name',
  },
  {
    id: 2,
    name: 'Depot Name',
    query: 'depot_name',
  },
];

const route_master = [
  {
    id: 1,
    name: 'Name',
    query: 'route_name',
  },
  {
    id: 2,
    name: 'Source',
    query: 'source_reference_id',
  },
  {
    id: 3,
    name: 'Destination',
    query: 'destination_reference_id',
  },
];

const activity_time = [
  {
    id: 1,
    name: 'Route Name',
    query: 'route_name',
  },
  {
    id: 2,
    name: 'Source',
    query: 'source_reference_id',
  },
  {
    id: 3,
    name: 'Destination',
    query: 'destination_reference_id',
  },
];

const transshipment = [
  {
    id: 1,
    name: 'Source',
    query: 'sourceRefsId',
  },
  {
    id: 2,
    name: 'Hub',
    query: 'hubRefsList',
  },
];

const material = [
  {
    id: 1,
    name: 'Material Code',
    query: 'query',
  },
  {
    id: 2,
    name: 'Name',
    query: 'name',
  },
  {
    id: 3,
    name: 'Business Unit',
    query: 'business_unit',
  },
  {
    id: 4,
    name: 'Category',
    query: 'category',
  },
];

const bfr = [
  {
    id: 1,
    name: 'Transporter Name',
    query: 'query',
  },
  {
    id: 2,
    name: 'Source',
    query: 'source',
  },
  {
    id: 3,
    name: 'City Ref',
    query: 'city_ref',
  },
];

const bucc = [{ id: 1, name: 'Code', tlabel: 'MDM_CODE', query: 'code' },
  { id: 2, name: 'Description', tlabel: 'MDM_DESCRIPTION', query: 'description' },
  { id: 3, name: 'Center', tlabel: 'MDM_CENTER', query: 'center' },
  { id: 4, name: 'Sector', tlabel: 'MDM_SECTOR', query: 'sector' }];

const purchase_order = [{
  id: 1, name: 'PO Number', tlabel: 'MDM_PO_NUMBER', query: 'po_number',
}];

const transit_management = [
  { id: 1, name: 'Source', tlabel: 'MDM_SOURCE', query: 'source' },
  { id: 2, name: 'Destination', tlabel: 'MDM_DESTINATION', query: 'destination' },
];

const materialcategory = [
  { id: 1, name: 'Name', tlabel: 'MDM_NAME', query: 'name' },
];

const redirection = [
  { id: 1, name: 'Order Type', tlabel: 'ORDER_TYPE', query: 'order_type' },
  { id: 2, name: 'Material Category', tlabel: 'MDM_ENTER_MATERIAL_CATEGORY_NAME', query: 'material_category' },
  { id: 3, name: 'Source Depot', tlabel: 'MDM_SOURCE_DEPOT', query: 'source_depot' },
  { id: 4, name: 'Redirection Depot', tlabel: 'MDM_REDIRECTION_DEPOT', query: 'redirection_depot' },
];

const freight_zone = [
  {
    id: 1,
    name: 'Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Pincode',
    query: 'pincode',
    inputType: 'number',
  },
];

const legal_entity = [
  {
    id: 1,
    name: 'Legal Entity Code',
    query: 'legal_entity_code',
  },
  {
    id: 2,
    name: ' Freight Invoice Company GSTIN',
    query: 'gstin',
  },
  {
    id: 3,
    name: 'Freight Invoice Company City',
    query: 'city',
  },
  {
    id: 4,
    name: 'Freight Invoice Company State',
    query: 'state',
  },
  {
    id: 5,
    name: ' LR Document Company Name',
    query: 'lr_document_company_name',
  },
  {
    id: 6,
    name: 'LR Document Company City',
    query: 'lr_document_company_city',
  },
  {
    id: 7,
    name: 'LR Document Company State',
    query: 'lr_document_company_state',
  },
];

const vehicle = [
  {
    id: 1,
    name: 'Name',
    query: 'query',
  },
];

// eslint-disable-next-line import/prefer-default-export
export const searchConstants = {
  carton,
  carrier,
  shipmethod,
  transportationdb,
  transporter,
  billdiscount,
  contract,
  vehicledetail,
  consignee,
  contracttsd,
  destination_charge,
  user,
  package_master,
  material_package_map,
  depot,
  sla,
  detention,
  material,
  route_master,
  bfr,
  activity_time,
  transshipment,
  source_charge,
  bucc,
  purchase_order,
  transit_management,
  materialcategory,
  redirection,
  freight_zone,
  legal_entity,
  vehicle,
};
